'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _riskByYear = require('./risk-by-year.component');

var _riskByYear2 = _interopRequireDefault(_riskByYear);

var _riskByYear3 = require('./risk-by-year.service');

var _riskByYear4 = _interopRequireDefault(_riskByYear3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports.riskByYear', [_angularUiRouter2.default]).component('riskByYear', _riskByYear2.default).service('RiskByYearService', _riskByYear4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('riskByYear', {
    parent: 'reports',
    url: '/risk-by-year',
    component: 'riskByYear',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/risk-by-year/risk-by-year.module.js